import React, { Fragment } from "react";
import { useState, useEffect, useRef } from "react";
import Navbar from "../Navbar";
import Footer from "../Footer";
import $ from "jquery";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {Checkmark} from 'react-checkmark';
import { useTranslation } from "react-i18next";



const { config } = require("../api/api");


const MotorPolicyStatusView = () => {

       
        const base_url = config.baseURL;
        const redirect_url=config.redirectURL;
      
        const [loading,setLoading]=useState(true);
    
        const [quoteNo,setQuoteNo]=useState("");
    
        const [quoteDetails,setQuoteDetails]=useState(null);
        const [vehicleDetails,setVehicleDetails]=useState(null);
        const [insuredDetails,setInsuredDetails]=useState(null);
        const [transactionDetails,setTransactionDetails]=useState(null);

        const [policyDocs,setPolicyDocs]=useState(null)

        const [openPolicyStatus,setOpenPolicyStatus]=useState(false);
        const [paymentStatus,setPaymentStatus]=useState("");
        const [startTimer,setStartTimer]=useState(0);
   
        const [openTimer,setOpenTimer]=useState(false);
        const [openMessageBox,setOpenMessageBox]= useState(false);
        const [message,setMessage]= useState("");
        const [vendorkey,setVendorkey] = useState('');
        
            
        const { t } = useTranslation();
        
        const [statementUpdate,setStatementUpdate]=useState("Policy conversion in progress. This may take a few moments. Please do not refresh.")
        
        useEffect(() => {
       
             const postvData = { organization_name: "Superjet" };
       
             if (vendorkey === '' || vendorkey === null || vendorkey === undefined) {
             
               
               fetch(base_url+'/create_organization', {
                 method: 'POST',
                 headers: {
                     'Content-Type': 'application/json',
                 },
                 body: JSON.stringify(postvData),
                 })
                 .then(response => response.json())
                 .then(data => {
                   
                   setVendorkey(data.result[0].vendor_key);
                   console.log(data.result[0].vendor_key,"vk1")
                 })
                 .catch(error => {
                     console.error('Error posting data:', error);
                 });
       
       
             }
           }, [vendorkey]);  

 useEffect(() => {
    debugger;

    const params = new URLSearchParams(window.location.search); 
    const quote_no = params.get("q_no");
    const payment_status = params.get("payment_status");
    setQuoteNo(quote_no);
    // setPaymentStatus(payment_status);

  }, []);

    
  let count = 0;







  
 useEffect(() => {
  debugger
  if (!quoteNo) return;

  const searchQuote = async (payload, policy_data) => {
    try {
      const response = await fetch(`${base_url}/search_quote`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${vendorkey}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        console.log("searching quote HTTP status:", response.status);
        return null;
      }

      const data = await response.json();

      if (data?.result?.effectiveDt && data?.result?.insuredDetails && data.result.transactionDetails?.policyNo && data.result.transactionDetails?.policyNo.includes("P")) {
        const policy_details = policy_data?.result || {};

        data.result = {
          ...data.result,
          premiumAmt: policy_details.premium_amount,
          planSelected: policy_details.plan_selection,
          paymentStatus: policy_details.payment_status,
        };

        setQuoteDetails(data.result);
        setVehicleDetails(data.result.vehicleDetails);
        setInsuredDetails(data.result.insuredDetails);
        setTransactionDetails(data.result.transactionDetails || null);
        setOpenPolicyStatus(true);

        return data.result.transactionDetails?.policyNo || null;
      }
      else if(data?.result?.effectiveDt && data?.result?.insuredDetails){
        const policy_details = policy_data?.result || {};

        data.result = {
          ...data.result,
          premiumAmt: policy_details.premium_amount,
          planSelected: policy_details.plan_selection,
          paymentStatus: policy_details.payment_status,
        };

        setQuoteDetails(data.result);
        setVehicleDetails(data.result.vehicleDetails);
        setInsuredDetails(data.result.insuredDetails);
        setTransactionDetails(data.result.transactionDetails || null);
        setOpenPolicyStatus(true);

        return  null;
      }

      return null;
    } catch (err) {
      console.error("Error in search quote api:", err);
      return null;
    }
  };

  const getPolicyDetails = async () => {
    try {
      debugger
      const response = await fetch(`${base_url}/get_motor_policy_details`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${vendorkey}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ quoteNo }),
      });

    if (!response.ok) {
    console.log("Getting policy details HTTP status:", response.status);
    throw new Error("No policy found");
    // return null; // unreachable, can remove
}


      return await response.json();
    } catch (err) {
      debugger
      if(err.message==="No policy found"){
        setOpenMessageBox(true);
        setMessage(err.message);
      }
      console.error("Error in get policy details api:", err);
      return null;
    }
  };

  const getPolicyDoc = async (payload) => {
    try {
     
      const response = await fetch(`${base_url}/get_policy_doc`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${vendorkey}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        console.log("policy doc HTTP status:", response.status);
        return;
      }

      const data = await response.json();
      if (data.message === "success" && data.result?.length > 0) {
        setPolicyDocs(data.result);
      }
    } catch (err) {
      console.error("Error in get policy doc api:", err);
    }
  };

  const callFunction = async () => {
    try {
      

      const get_policy_info = await getPolicyDetails();
        var policy_data = get_policy_info;
        
        setPaymentStatus(get_policy_info?.result?.payment_status?.toLowerCase());

      if (get_policy_info?.message === "success" && get_policy_info.result.payment_status==="success") {

        const fetchAndSetPolicyDoc = async () => {
             setLoading(true);
          const policy_payload = {
        civilId: "",
        plateNo: "",
        registrationMark: "",
        srcBusId: "SJET",
        txnTyp: "P",
        mobileNo: "",
        policyNo: "",
        quoteNo,
        searchTyp: "",
      };
          const policy_no = await searchQuote(policy_payload, policy_data);
          if (policy_no && policy_no.includes("P")) {
            setOpenTimer(false);
            await getPolicyDoc({
              civilId: "",
              plateNo: "",
              registrationMark: "",
              srcBusId: "SJET",
              mobileNo: "",
              policyNo: policy_no,
            });
            return policy_no;
          }
          
          return null;
        };


        //end
debugger
        // case 1: policy_no is available (not pending and not null)
        if ( get_policy_info.result.policy_no !== "pending" && get_policy_info.result.policy_no.includes("P")) {
          await fetchAndSetPolicyDoc();
          setTimeout(()=> {
            setLoading(false)
          },500);
          setOpenTimer(false);
        } else {
          // case 2: wait for 30 seconds then retry
          setStartTimer(40);
          console.log("timer : ",startTimer);
          setOpenTimer(true)


        const checkPolicy = async () => {
  count++;

  const get_policy_no = await fetchAndSetPolicyDoc();
  if (get_policy_no && get_policy_no.includes("P")) {
    setTimeout(() => setLoading(false), 500);
    return; // stop here (no more recursion)
  }

  if (count === 1) {
     setStartTimer(25);
    setStatementUpdate("Your policy conversion is still processing, taking longer than usual. Please wait.");
    setTimeout(checkPolicy, 25000);
  }
  if(count === 2){
       setStartTimer(15);
    setStatementUpdate("Policy conversion is in progress; final step may require additional processing time.");
    setTimeout(checkPolicy, 15000);
  }
  if (count === 3) {

    setLoading(false);
    setOpenTimer(false);
    setStartTimer(0);
    setOpenMessageBox(true);
    setMessage("The request cannot be completed at the moment. Please try again.")
    return; // stop after 2 tries
  }

  // schedule next check after 35s
  
};
   
          setTimeout(checkPolicy,40000);

        }
      }
      else if(get_policy_info?.message === "success" && get_policy_info.result.payment_status!=="success"){
  const policy_payload = {
        civilId: "",
        plateNo: "",
        registrationMark: "",
        srcBusId: "SJET",
        txnTyp: "Q",
        mobileNo: "",
        policyNo: "",
        quoteNo,
        searchTyp: "",
      };
       await searchQuote(policy_payload, policy_data);
}
    } catch (err) {
      console.error("Error in callFunction:", err);
    } finally {
      setTimeout(() => setLoading(false), 1000);
    }
  };
if(vendorkey){
  callFunction();
}
}, [quoteNo,vendorkey]);




const handleRetryPayment=async(e)=>{
  // payment api 
  e.preventDefault();

      const payment_data={
      "quoteNo":quoteDetails?.renewalQuoteNo || transactionDetails?.quoteNo,
      "amount": quoteDetails.premiumAmt
  }
  
    const response = await fetch(base_url+"/motor_ins_payments",{
    method:"POST",
    headers:{
      "Authorization": `Bearer ${vendorkey}`,
      "Content-Type": "application/json"
    },
    body:JSON.stringify(payment_data)
  });
  if(!response.ok){
    console.log("payment fetch HTTP status :", response.status);
    }
  
    const payment_response = await response.json();
  
    if(payment_response.message==="success"){
  
      if(payment_response.result.success && payment_response.result.message==="Payment Link Generated Successfully" ){
  
        const url = payment_response.result.data
  
        if(url){
  
            window.location.href=url;
        }
  
      }
    }
    else{
      toast.error("Payment process not initiated");
    }
  
}


  const handleDocs=(e,url)=>{
    e.preventDefault();
    const element = document.createElement("a");
    element.target="_blank"
    element.href=url;
    element.click();

  }

  const handleRefresh=(e)=>{
    e.preventDefault();
    window.location.reload();
  }

useEffect(() => {
  let timer;
  if (startTimer > 0) {
    timer = setTimeout(() => {
      setStartTimer((prev) => prev - 1);
    }, 1000);
  }

  return () => clearTimeout(timer); // cleanup on re-render/unmount
}, [startTimer]);



    
        return (
        <>

 <div className="header_section1">
        <Navbar />

        <div className="container-fluid bg-breadcrumb">
          <div className="container text-center py-5">
            <h3 className="abt-txt my-5  fs-sm-6" style={{}}>{t("Policy Status")} {paymentStatus==="success" ?transactionDetails?.policyNo && transactionDetails?.policyNo.includes("P") ?"- "+transactionDetails?.policyNo:"":""}</h3>
          </div>
        </div>
      </div>

           <div className="features_section">
        <div className="container mt-5">
 { <div className={`row mt-5 ${paymentStatus!=="success"?"d-flex justify-content-center":""}`} style={{alignContent:"center"}}>


     
 {  (openPolicyStatus && quoteDetails)  && 
 <>

 <div className={`col-lg-6 mt-3`} >
    <div className="card p-4 mx-3 ">

    <div className='my-2 '>
    
                                          <h1>
                                       <span style={{display:"inline-block",position:"relative",top:"2px"}}>
                                        { paymentStatus==="success"?
                                         <><svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 24 24" fill="none" stroke="green" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-circle-check-big-icon lucide-circle-check-big"><path d="M21.801 10A10 10 0 1 1 17 3.335"/><path d="m9 11 3 3L22 4"/></svg></>:
                                        <><svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 24 24" fill="none" stroke="red" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-circle-x-icon lucide-circle-x"><circle cx="12" cy="12" r="10"/><path d="m15 9-6 6"/><path d="m9 9 6 6"/></svg></> }
                            </span>&nbsp;{paymentStatus?
                            paymentStatus.charAt(0).toUpperCase() + paymentStatus.slice(1).toLowerCase():
                            ""} </h1>
                                    
                                    
                                    
                                      </div>
                                   
    

    <table className="w-100 px-2 py-4">
    <tbody >
        {(paymentStatus==="success" && transactionDetails?.policyNo && transactionDetails?.policyNo.includes("P")) && <tr>
            <td className='border px-2 py-2'>
    {t('Policy No')}
            </td>
            <td className='border px-2 py-2'>
    {transactionDetails?.policyNo}  
            </td>
        </tr>}
        <tr>
            <td className='border px-2 py-2'>
    {t('Quote No')}
            </td>
            <td className='border px-2 py-2'>
               {transactionDetails?.quoteNo}  

            </td>
        </tr>
         <tr>
            <td className='border px-2 py-2'>
    {t('Cover From Date')}
            </td>
            <td className='border px-2 py-2'>
               {quoteDetails?.effectiveDt}  
            </td>
        </tr>
          <tr >
            <td className='border px-2 py-2'>
    {t('Cover To Date')}
            </td>
            <td className='border px-2 py-2'>
               {quoteDetails?.expirationDt}  
            </td>
        </tr>
          <tr >
            <td className='border px-2 py-2'>
    {t('Insured Name')}
            </td>
            <td className='border px-2 py-2'>
               {insuredDetails?.insureFullName}  
            </td>
        </tr>

         <tr >
            <td className='border px-2 py-2'>
    {t('Plate No')}
            </td>
            <td className='border px-2 py-2'>
               {vehicleDetails?.vehRegNo}  
            </td>
        </tr>
        <tr >
            <td className='border px-2 py-2'>
    {t('Plate Code')}
            </td>
            <td className='border px-2 py-2'>
               {vehicleDetails?.vehRegLOC}  
            </td>
        </tr>

          <tr >
            <td className='border px-2 py-2'>
    {t('Premium')}
            </td>
            <td className='border px-2 py-2'>
               { quoteDetails.premiumAmt +" OMR"}  
            </td>
        </tr>
          <tr>
            <td className='border px-2 py-2'>
    {t('Product')}
            </td>
            <td className='border px-2 py-2'>
               {quoteDetails?.prodId}  
            </td>
        </tr>
        <tr>
            <td className='border px-2 py-2'>
    {t('Plan')}
            </td>
            <td className='border px-2 py-2'>
               {quoteDetails?.planSelection ||quoteDetails.planSelected}  
            </td>
        </tr>
        <tr>
            <td className='border px-2 py-2'>
    {t('Payment Status')}
            </td>
            <td className='border px-2 py-2'>
               {quoteDetails.paymentStatus}  
            </td>
        </tr>
    </tbody>
    </table>


    </div>

  
           </div>   
           </> 
                    
  }
    
   {(policyDocs && policyDocs?.length>0 )&& <div className="col-lg-6 mt-3" >
        <div className='card p-4 mx-3 '>
    <div className='mb-2'>
                    <h1>{t("Policy Documents")}</h1>
    </div>
                                    
        <div className=" d-flex  px-3 py-4 ">
        <div className="row">
       { policyDocs?.length>0 &&
       
       policyDocs.map((docs)=>(

        <div className="col-12 col-md-6  mb-4">
       <h3> {docs.name.replace(" - 0","")}</h3>
      
       <button className="btn btn-primary w-md-100 w-lg-100 "  style={{width:"80%",whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}
       onClick={(e)=>handleDocs(e,docs.url)}>
              <span className="d-inline=-block " style={{position:"relative",top:"3px"}}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-download" viewBox="0 0 16 16">
  <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5"/>
  <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708z"/>
</svg></span><span style={{marginLeft:"10px"}}>  {docs.url.substring(docs.url.lastIndexOf("=")+1,docs.url.length)} </span>
       </button>
   
        </div>
        ))}
        </div>
        </div>
          </div>  
    </div>
    }
   {  (openPolicyStatus && quoteDetails)  && <div className="col-12 d-flex  justify-content-center mt-3">
      <div>
      <button className="btn btn-primary mt-3 mr-3" onClick={(e)=>{e.preventDefault(); window.location.href="/";}}>
        {t("Go To Home")}
      </button>
      </div>
        {
      paymentStatus !=="success" || quoteDetails?.paymentStatus !=="success"?
      <div className=""> <button type="button" className="btn btn-primary mt-3 " onClick={(e)=>handleRetryPayment(e)}>{t("Retry Payment")}</button>
      </div>
      :""
      
    }
      </div>}
    </div>
    }
    </div>
    </div>

    {
      (openTimer && startTimer>0) &&  
      <>
      <div className="row mb-5" style={{height:"30vh",justifyContent:"center",alignContent:"center"}}>
      <div>

      <div className="d-flex justify-content-center mb-2">
      <img src="/gifs/file_animation.gif" alt="Preparing..." style={{width:"150px"}} />

      </div>
      <h1 className="d-flex justify-content-center " style={{fontWeight:"600"}}>{startTimer}&nbsp;{t("Secs")}</h1>


      <div className=" mx-5 mt-3 d-flex justify-content-center">
      <h3>
     {statementUpdate}
     </h3>
      </div>
      </div>
      </div>
      </>
    }

    <Footer />


    {/* {
      (!openPolicyStatus && !loading )&&
      <>
      <div className="row" style={{height:"80vh",justifyContent:"center",alignContent:"center"}}>
      <div>
      <h1>Try again</h1>


      <div className="w-100 mt-3 d-flex justify-content-center">
      <button className="" onClick={(e)=>handleRefresh(e)}>
      Refresh
      </button>
      </div>
      </div>
      </div>
      </> 
    } */}
{
  openMessageBox  && (
        <div className='modal'>
          <div className='modal-content' style={{height: "auto" , width:'600px'}}>
         
          {/* <button type="button" className="close" onClick={handleClose}>
          &times;
          </button> */}
          
          <div>
          <div style={{textAlign:"left"}}>{message}</div>
          
          <hr></hr>
          <div>
          {
            message!=="No policy found"&&
          <button type="button" className="btn btn-primary mt-3" aria-label="Close" onClick={handleRefresh}>{t("Try again")}</button>
          }
          </div>

          </div>
          </div>
        </div>
      )
}

   

    {
      (!openTimer && loading) && (
            <div className="overlay">
              <div className="spinner">
              </div>
            </div>
          )
    }
    
        </>
        
        )
    
}

export default MotorPolicyStatusView;